export default __webpack_public_path__ + "static/Roobert-Medium-6681d59ba7ed52d5015fefe73179d319.woff2";